import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';

const headings = [
  {
    text: 'Your Feed',
    route: '/takes/feed',
    isProtected: false,
  },
  {
    text: 'X Takes',
    route: '/takes/twitterTakes',
    isProtected: false,
  },
  {
    text: 'Write',
    route: '/takes/write',
    isProtected: true,
  },
  {
    text: 'Invite',
    route: '/invite',
    isProtected: true,
  },
];

const Bottombar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [{ user }] = useGlobalState();
  const { openLogin } = useLoginHelper();

  function isActive(route) {
    return location.pathname.includes(route);
  }

  function handleRoute(route, isProtected) {
    if (isProtected && !user?.address) {
      return openLogin();
    }
    navigate(route);
  }

  return (
    <Flexbox className='lowerbar_container' justifyContent='space-evenly'>
      {headings.map((item, _idx) => (
        <ThemedText.H6
          className={isActive(item?.route) ? 'active' : 'non-active'}
          weight={isActive(item?.route) ? 'semi-bold' : 'normal'}
          onClick={() => handleRoute(item?.route, item?.isProtected)}
        >
          {item?.text}
        </ThemedText.H6>
      ))}
    </Flexbox>
  );
};

export default Bottombar;
